import script from "./RaceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RaceCard.vue?vue&type=script&setup=true&lang=ts"

import "./RaceCard.vue?vue&type=style&index=0&id=0366d27c&lang=css"

const __exports__ = script;

export default __exports__